export const podcastThemeNamesMap = {
  'Courier Life': {
    inverse: true,
    link: 'sunshine',
    main: 'military',
    previewText: 'liquorice',
    subheader: 'liquorice',
    text: 'snow',
    title: 'snow',
  },
  'Courier Weekly': {
    inverse: false,
    link: 'sunshine',
    main: 'seafoam',
    previewText: 'liquorice',
    subheader: 'liquorice',
    text: 'liquorice',
    title: 'snow',
  },
  'Courier Workshop Weekly': {
    inverse: true,
    link: 'sunshine',
    main: 'military',
    previewText: 'liquorice',
    subheader: 'liquorice',
    text: 'snow',
    title: 'snow',
  },
  'Weekly Signup': {
    inverse: false,
    main: 'grayish',
    subheader: 'liquorice',
    text: 'liquorice',
    title: 'seafoam',
  },
  'Workshop Signup': {
    inverse: false,
    main: 'grayish',
    subheader: 'liquorice',
    text: 'liquorice',
    title: 'military',
  },
};

export const podcastTextMap = {
  'Courier Weekly': {
    subhead: 'Stories of modern business.',
    title: 'Weekly',
  },
  'Courier Workshop Weekly': {
    subhead: 'Insights, advice and know-how.',
    title: 'Workshop',
  },
  'Weekly Signup': {
    cardHeader: 'Subscribe to Weekly',
    cardText:
      'A weekly email full of useful stories, tips, tricks and simply good advice on how to get stuff done.',
    subhead: 'Stories of modern business.',
    title: 'Weekly',
  },
  'Workshop Signup': {
    cardHeader: 'Subscribe to Workshop',
    cardText:
      'Get a weekly dose of business tips, guides, case studies and expert insights to help you start or grow your business.',
    subhead: 'Insights, advice and know-how.',
    title: 'Workshop',
  },
};
